import React from 'react';
import Header from '~components/header';
import Navigation from '~components/navigation';
import MainLoader from '~components/main-loader';
import { isSafari } from '~utils/helpers';

function PagePreloader() {
    const windowWidth = isSafari() ? document.documentElement.clientWidth : window.innerWidth;
    const isMobile = windowWidth < 1160;
    return (
        <React.Fragment>
            <Header>
                <Navigation isMobile={isMobile} />
            </Header>
            <div className="main">
                <MainLoader />
            </div>
        </React.Fragment>
    );
}

export default PagePreloader;
export { PagePreloader };



// WEBPACK FOOTER //
// ./src/components/page-preloader/index.js